import { z } from 'zod';

/**
 * Schéma pour la création/édition d'un chapitre
 * Mise à jour : utilise teachingId au lieu de subjectId
 */
export const chapterSchema = z.object({
  title: z.string().min(3, 'Le titre doit contenir au moins 3 caractères'),
  description: z.string().optional(),
  orderNumber: z.coerce
    .number()
    .min(1, "L'ordre doit être au moins 1")
    .max(100, "L'ordre ne peut pas dépasser 100"),
  estimatedHours: z.coerce
    .number()
    .min(0.5, 'La durée estimée doit être au moins 0.5 heure')
    .max(500, 'La durée estimée ne peut pas dépasser 500 heures')
    .optional(),
  statusId: z.coerce.number().min(1, 'Le statut est requis'),
  teachingId: z.string().min(1, "L'enseignement est requis"),
  periodId: z.string().optional(),
});

export type ChapterFormData = z.infer<typeof chapterSchema>;
